import { createTheme } from "@mui/material";

export const defaultRootStyle = {
  padding: {
    p1624: "16px 24px",
    p1211: "16px 24px 16px 16px",
    p1112: "16px  16px 16px 24px",
    p16: "16px",
  },
  palette: {
    primary: {
      main: "#1E87FF",
      accent: "#10519C",
    },
    secondary: {
      main: "#EDF5FF",
    },
    black: "#292727",
    grey: "#98A2B3",
    white: "#FFFFFF",
    red: "#F23030",
    success: "#32D583",
    success_soft: "#ECFDF3",
    error: "#F97066",
    error_soft: "#FEF3F2",
    background: "#F7FAFC",
    hover: "#EDF5FF",
    hold: "#F4B40E",
    primary_soft: "#EDF5FF",
    dividers: "#D0D5DD",
  },
  borderRadius: {
    lg: "8px",
  },
  border: {
    sm: "1px solid #1E87FF;",
  },
  fontFamily: {
    inter: "Inter",
  },
};

export const defaultRootTheme = createTheme({
  palette: {
    primary: {
      main: "#1E87FF",
      accent: "#10519C",
    },
    secondary: {
      main: "#EDF5FF",
      black: "#292727",
      grey: "#98A2B3",
      white: "#FFFFFF",
      red: "#F23030",
      success: "#32D583",
      success_soft: "#ECFDF3",
      error: "#F97066",
      error_soft: "#FEF3F2",
      background: "#F7FAFC",
      hover: "#EDF5FF",
      hold: "#F4B40E",
      primary_soft: "#EDF5FF",
      dividers: "#D0D5DD",
    },
  },
  button: {
    padding: {
      p1211: defaultRootStyle.padding.p1211,
      p16: defaultRootStyle.padding.p16,
      p1624: defaultRootStyle.padding.p1624,
    },
    primary: {
      textTransform: "none",
      background: defaultRootStyle.palette.primary.main,
      padding: defaultRootStyle.padding.p1624,
      borderRadius: defaultRootStyle.borderRadius.lg,
      ":hover": {
        background: defaultRootStyle.palette.primary.accent,
        boxShadow: "none",
      },
      ":active": {
        boxShadow: "none",
      },
      fontFamily: defaultRootStyle.fontFamily.inter,
    },
    secondary: {
      textTransform: "none",
      fontFamily: defaultRootStyle.fontFamily.inter,
      background: defaultRootStyle.palette.secondary.main,
      padding: defaultRootStyle.padding.p1624,
      color: defaultRootStyle.palette.primary.main,
      borderRadius: defaultRootStyle.borderRadius.lg,
      ":hover": {
        border: defaultRootStyle.border.sm,
        background: defaultRootStyle.palette.secondary.main,
        boxShadow: "none",
      },
      ":active": {
        boxShadow: "none",
      },
    },
    text: {
      textTransform: "none",
      color: defaultRootStyle.palette.primary.main,
      fontFamily: defaultRootStyle.fontFamily.inter,
      padding: defaultRootStyle.padding.p1624,
      borderRadius: defaultRootStyle.borderRadius.lg,
      ":hover": {
        background: defaultRootStyle.palette.secondary.main,
        border: defaultRootStyle.border.sm,
      },
    },
    navitem: {
      color: defaultRootStyle.palette.primary.main,
      padding: defaultRootStyle.padding.p16,
      borderRadius: defaultRootStyle.borderRadius.lg,
      ":hover": {
        background: "none",
        borderBottom: "2px solid #1E87FF",
        borderRadius: "0px",
      },
    },
  },
  typography: {
    heading: {
      fontFamily: "Inter",
      fontWeight: "bold",
      fontSize: "24px",
      lineHeight: "auto",
    },
    body: {
      fontFamily: "Inter",
      fontWeight: "Regular",
      fontSize: "14px",
      lineHeight: "auto",
    },
    button: {
      fontFamily: defaultRootStyle.fontFamily.inter,
      fontWeight: "Bold",
      fontSize: "14px",
      lineHeight: "24px",
      textTransform: "none",
    },
    textArea: {
      fontFamily: "Inter",
      fontWeight: "Regular",
      fontSize: "14px",
      lineHeight: "24px",
    },
    inputTitle: {
      fontFamily: "Inter",
      fontWeight: "Regular",
      fontSize: "12px",
      lineHeight: "auto",
    },
    bodyHeading: {
      fontFamily: "Inter",
      fontWeight: "bold",
      fontSize: "18px",
      lineHeight: "auto",
    },
    bodyDescription: {
      fontFamily: "Inter",
      fontWeight: "regular",
      fontSize: "12px",
      lineHeight: "auto",
    },
    headingDescription: {
      fontFamily: "Inter",
      fontWeight: "Light",
      fontSize: "16px",
      lineHeight: "24px",
    },
    subtitle1: {
      color: defaultRootStyle.palette.black,
      textAlign: "center",
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 500,
      width: { xs: "252px", sm: "503px" },
    },
    tableheading: {
      fontFamily: "Inter",
      fontWeight: "Bold",
      fontSize: "12px",
      lineHeight: "100%",
    },
    tableContent: {
      fontFamily: "Inter",
      fontWeight: "Regular",
      fontSize: "12px",
      lineHeight: "auto",
    },
    sideNav: {
      fontFamily: "Inter",
      fontWeight: "semibold",
      fontSize: "14px",
      lineHeight: "auto",
    },
    tabInactive: {
      fontFamily: "Inter",
      fontWeight: "regular",
      fontSize: "12px",
      lineHeight: "100%",
    },
    tabActive: {
      fontFamily: "Inter",
      fontWeight: "Bold",
      fontSize: "12px",
      lineHeight: "100%",
    },
    bodyTitle: {
      fontFamily: "Inter",
      fontWeight: "Medium",
      fontSize: "12px",
      lineHeight: "auto",
    },
    headBig: {
      color: "#000",
      fontSize: { xs: "23px", sm: "48px" },
      fontFamily: "Inter",
      fontWeight: 700,
      lineHeight: "Auto",
    },
    chip: {
      color: "#98A2B3",
      fontSize: "12px",
      fontFamily: "Inter",
      fontWeight: 500,
      lineHeight: "16px",
    },
  },

  dropShadow: {
    background: "#FFFFFF",
    boxShadow: "0px 2px 45px rgba(65, 63, 63, 0.1)",
  },
});
